import { EasmScanConfigurationBaseDataProvider } from './EasmScanConfigurationBaseDataProvider';

export class EasmScanConfigurationNirvanaDataProvider extends EasmScanConfigurationBaseDataProvider {
  public async getDataForView(): Promise<any> {
    return {};
  }
}
